import { c as _c } from "react/compiler-runtime";
import { useProjectApiClient } from "@api/project-api/use-project-api-client";
import { capturedDataFetchingStatusSelector } from "@store/captured-data/captured-data-selector";
import { fetchCapturedData } from "@store/captured-data/captured-data-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { useEffect, useRef } from "react";

/**
 * Fetches the 360 photos of the project once and stores them in the redux store.
 * Use `capturedDataSelector` to read them.
 */
export function useFetchCapturedData(t0) {
  const $ = _c(10);
  const {
    projectId
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== projectId) {
    t1 = {
      projectId
    };
    $[0] = projectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const projectApiClient = useProjectApiClient(t1);
  const fetchingStatus = useAppSelector(capturedDataFetchingStatusSelector);
  const fetchRequestRef = useRef(undefined);
  let t2;
  let t3;
  if ($[2] !== dispatch || $[3] !== fetchingStatus || $[4] !== projectApiClient) {
    t2 = () => {
      if (fetchingStatus !== "uninitialized") {
        return;
      }
      fetchRequestRef.current = dispatch(fetchCapturedData({
        projectApiClient
      }));
    };
    t3 = [dispatch, fetchingStatus, projectApiClient];
    $[2] = dispatch;
    $[3] = fetchingStatus;
    $[4] = projectApiClient;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      fetchRequestRef.current?.abort();
      fetchRequestRef.current = undefined;
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== projectId) {
    t5 = [projectId];
    $[8] = projectId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
}